<template>
    <div class="feedback">
        <!-- <div class="navlist-box">
            <tab :tabList="feedbackTab" :name="'dataTab'" @onSwitch="tabSwitch"></tab>
        </div> -->
        <div class="feedback-container">
            <div class="feedback-content">
                <div class="form-title">
                    <span>反馈类型</span>
                    <span>*</span>
                </div>
                <div class="feedback-type">
                    <div class="type-item" @click="changeFeedbackType(index)" :class="{'type-item-active': item.check}" v-for="(item, index) in feedbackType" :key="item.name">
                        <span>{{item.name}}</span>
                        <span>{{item.text}}</span>
                    </div>
                </div>
                <div class="form-title">
                    <span>涉及业务</span>
                    <span>*</span>
                    <div class="selector-business">
                        <span @click="() => {this.show = true}" class="tip-text" :class="{'tip-text-active': formValidated.noSystem.name}">{{formValidated.noSystem.name || formValidated.business}}</span>
                        <img class="feedback-next" src="../../assets/image/feedback_next.png" alt="">
                    </div>
                </div>
                <div class="business-type">
                    <div @click="deleteTypeItem(index)" class="business-type-item" v-for="(item, index) in formValidated.businessType" :key="item.name">
                        <span>{{item.name}}</span><img class="feedback-close" src="../../assets/image/feedback_close.png" alt="">
                    </div>
                </div>
                <div class="form-title">
                    <span>问题描述</span>
                    <span>*</span>
                </div>
                <div class="description">
                    <van-field
                        v-model="formValidated.message"
                        rows="6"
                        autosize
                        type="textarea"
                        maxlength="500"
                         />
                    <p class="description-limit">500字以内</p>
                </div>  
                <div class="form-title">
                    <span>相关凭证</span>
                </div>
                <div class="feedback-upload">
                    <div v-if="fileListUpload.length > 0" class="upload-item" v-for="(item, index) in fileListUpload" :key="index+item.file.lastModified">
                        <div v-if="item.status != 'done'" class="preview-mask upload-img">
                            <van-loading v-if="item.status=='uploading'" size="24" />
                            <van-icon v-if="item.status=='failed'" name="close" />
                            <span>{{item.message}}</span>
                        </div>
                        <img :src="item.content" alt="" class="upload-img" @click="showViewer(0, $event, [item.content])" v-if="item.file.type.indexOf('image') != -1">
                        <video :ref="index" v-else autoplay class="upload-img">
                            <source :src="item.content" type="video/mp4">
                                您的浏览器不支持Video标签。
                        </video>
                        <div class="fullScrenn" @click="clickAutoPlay(item.content)" v-if="item.file.type.indexOf('image') == -1"></div>
                        <img v-if="item.status !== 'uploading'" @click="uploadDeleteImg(index)" class="upload-delete" src="../../assets/image/feedback_delete.png" alt="" />
                    </div>
                    <van-uploader class="upload-camera" :class="{'upload-camera-none': fileListUpload.length === 0}" multiple accept="video/*,image/*" v-model="fileListUpload" :max-count="9" :preview-image="false" :after-read="afterRead">
                        <!-- <template v-slot:preview-cover>
                            <div v-for="(item, index) in fileListUpload" :key="index">
                                <img :src="item.content" alt="" v-if="item.file.type.indexOf('image') != -1">
                                    <video v-else autoplay controls>
                                    <source :src="item.content" type="video/mp4">
                                     您的浏览器不支持Video标签。
                                    </video>
                                
                            </div>
                        </template> -->
                        <img src="../../assets/image/feedback_upload.png" alt=""></img>
                    </van-uploader>
                </div>
            </div>
        </div>
        <div class="feedback-submit">
            <van-button class="feedback-button" :class="{'feedback-button-disabled': !verify}" @click="submit" type="primary">提交</van-button>
        </div>
        <popup :parentNoSystem="formValidated.noSystem" :parentBusinessType="formValidated.businessType"  :show="show" @change-seletor="changeSelector" @change-close="changeClose"></popup>
        <!-- <popupVideo :show="showVideo" :fileUrl="fileVideo" @close="close" /> -->
    </div>
</template>

<script>
    import tab from 'comps/tab';
    import popup from './components/popup.vue';
    import popupVideo from './components/popupVideo.vue'
    import { mapActions } from 'vuex'
    import api from '../../service/modules/feedback'
    import util from '@/utils/util';
    import { Notify } from 'vant';
    import _ from 'lodash'
    export default {
        name: 'Feedback',
        components: {
            tab,
            popup,
            popupVideo
        },
        data() {
            return {
                showVideo: false,
                fileVideo: '',
                loadingImg: false,
                fileListUpload: [],
                feedbackType: [
                    {name: '账号问题', text: '账号权限、登录', check: false, feedbackType: 0},
                    {name: '平台性能', text: '系统卡顿、闪退', check: false, feedbackType: 1},
                    {name: '产品意见', text: '业务流程、制度', check: false, feedbackType: 2},
                ],
                initFeedBackType: {},
                fileList: [],
                feedbackTab: ['意见反馈', '我的反馈'],
                formValidated: {
                    message: '',
                    business: '请选择',
                    businessType: [],
                    noSystem: {}
                },
                initFormValidated: {},
                show: false,
                cos: {},
                cosArg: {},
                userList: JSON.parse(localStorage.getItem('integrityInfo')),
                barcodeUrl: ''
            }
        },
        computed: {
            verify() {
                return this.feedbackType.filter(item => item.check).length && (this.formValidated.businessType.length || Object.keys(this.formValidated.noSystem).length) && this.formValidated.message
            }
        },
        watch: {

        },
        methods: {
            ...mapActions('feedback', 
            [
                'getUploadUrl',
            ]),
            changeFeedbackType(index) {
                this.feedbackType.forEach(item => {
                    item.check = false
                })
                this.feedbackType[index].check = true
            },
            deleteTypeItem(index) {
                this.formValidated.businessType.splice(index, 1)
            },
            uploadDeleteImg(index) {
                this.fileList.splice(index, 1)
                this.fileListUpload.splice(index, 1)
            },
            tabSwitch(index) {

            },
            showViewer (index, event, imgList) {
                console.log('index',index)
                this.$ImagePreview({ images: imgList, startPosition: index, closeOnPopstate: true });
            },
            submit() {
                if (!this.verify) return
                if (util.cookies.get('X-Token')) {
                    localStorage.setItem('X-Token', util.cookies.get('X-Token'));
                }
                const params = {
                    feedbackType: this.feedbackType.filter(item => item.check)[0].feedbackType,
                    feedbackChannel: 1,
                    systemIds: this.formValidated.businessType.length ? this.formValidated.businessType.filter(item => item.code).map(item => item.code) : [this.formValidated.noSystem.code],
                    feedbackContent: this.formValidated.message,
                    files: this.fileList
                }
                // let config = {
                //     headers: {
                //         // 添加请求头
                //         'Content-Type': 'application/json;charset=UTF-8',
                //          'x-Token': util.cookies.get('X-Token') || localStorage.getItem('X-Token') || 'ODkwYWU2ZTctMzY0OC00NTY0LThmNzktMTRlOGE1MTJjYjUw'
                //     }
                // };
                // this.axios.post('/feedback-backend/ordinary/feedbackUser/save', params, config)
                //         .then(res => {
                //             this.formValidated = _.cloneDeep(this.initFormValidated);
                //             this.fileList = [];
                //             this.feedbackType = _.cloneDeep(this.initFeedBackType);
                //         });
                api.save(params).then(res => {
                    this.$toast("提交成功");
                    this.formValidated = _.cloneDeep(this.initFormValidated);
                    this.fileList = [];
                    this.fileListUpload = [];
                    this.feedbackType = _.cloneDeep(this.initFeedBackType);
                })
            },
            afterRead(file) {
                console.log('afterRead', file)
                console.log('this.fileListUpload',this.fileListUpload)
                let fileUpload = [];
                if (file instanceof Array) {
                    fileUpload = file;
                } else {
                    fileUpload = [file];
                }
                fileUpload.forEach(item => {
                    console.log(item)
                    item.status = 'uploading';
                    item.message = '上传中...';
                    let data = {
                        contentType: item.file.type,
                        type: item.file.name.substring(item.file.name.indexOf('.')+1).toLowerCase(),
                        fileName: item.file.name.substring(0, item.file.name.indexOf('.'))
                    }
                    console.log('data', data)

                    this.getUploadUrl(data).then(result => {
                        this.fileList.push({
                            fileUri: result.loadUrl,
                            fileKind: data.contentType.indexOf('image') !== -1 ? 0 : 1,
                            fileType: item.file.type, 
                            fileName: data.fileName, 
                            fileSize: item.file.size
                        })
                        console.log(this.fileList)
                        if (item.file.type == 'video/quicktime') {
                            item.status = 'failed';
                            item.message = '上传失败';
                            return Notify({ type: 'danger',message: '暂不支持mov格式的视频上传，请选择mp4格式视频文件'});
                        }
                        let formData = new FormData();
                        // 向 formData 对象中添加文件
                        formData.append('file', item.file);
                        // this.loadingImg = true;
                        this.axios.put(result.cosUrl, formData.get('file'), {
                            headers: {
                                'x-Token': util.cookies.get('X-Token') || localStorage.getItem('X-Token') || 'ODkwYWU2ZTctMzY0OC00NTY0LThmNzktMTRlOGE1MTJjYjUw',
                                'Content-Type': data.contentType
                            }
                        })
                            .then(res => {
                                item.status = 'done';
                                console.log(res)
                            }).catch(err => {
                                item.status = 'failed';
                                item.message = '上传失败';
                            }).finally(() => {
                                // this.loadingImg = false;
                            });
                    })
                })
            },
            beforeRead(file) {
                console.log('this.fileListUpload',this.fileListUpload)
                
                
            },
            changeSelector(value) {
                console.log(value)
                // Array.isArray
                if (Object.prototype.toString.call(value) === '[object Object]') {
                    this.formValidated.noSystem = value
                    this.formValidated.businessType = []
                } else {
                    this.formValidated.businessType = value
                    this.formValidated.noSystem = {}
                    this.business = '请选择'
                }
                
                this.show = false
            },
            changeClose() {
                this.show = false
            },
            clickAutoPlay(index) {
                // console.log(index)
                this.$forceUpdate()
                // this.showVideo = true;
                // this.fileVideo = index;
                sessionStorage.setItem('videoUrl', index)
                this.$router.push('/previewVideo')
                // let video = this.$refs[index]
                // console.log(video[0])
                // if(video[0].requestFullscreen) {
                //     video[0].requestFullscreen();
                // } else if(video[0].mozRequestFullScreen) {
                //     video[0].mozRequestFullScreen();
                // } else if(video.webkitRequestFullscreen) {
                //     video[0].webkitRequestFullscreen();
                // } else if(video[0].msRequestFullscreen) {
                //     video[0].msRequestFullscreen();
                // }
            },
            close() {
                this.showVideo = false;
                this.fileUri = ''
            }
        },
        created() {
            // this.getBarcode()
            this.initFormValidated = _.cloneDeep(this.formValidated)
            this.initFeedBackType = _.cloneDeep(this.feedbackType)
        },
        mounted() {
            
        }
    }
</script>

<style lang="less" scoped>
    .van-loading {
        top: 50%;
        font-size: 20px;
        left: 32%;
        transform: translateY(-50%);
    }
    .fullScrenn {
        position: absolute;
        top: 10px;
        height: 0;
        width: 76px;
        height: 76px;
    }
    .preview-mask {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        justify-content: center;
        color: #fff;
        background-color: rgba(50,50,51,.88);
        .van-icon-close {
            top: 50%;
            font-size: 20px;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        span {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            color: #fff;
            z-index: 9999;
        }
    }
    .feedback{
        width: 100%;
        // background: rgba(251, 251, 251, 1);
        box-sizing: border-box;
        // padding-bottom: 90px;
        font-family: PingFangSC-Regular;
        // padding-top: 56px;

        .navlist-box {
            width: 100%;
            height: 56px;
            box-sizing: border-box;
            padding-top: 6px;
            background-color: #fff;
            padding-left: 12px;
            position: fixed;
            left: 0;
            top: 0;
        }
        &-container{
            display: flex;
            padding: 0 16px;
            margin-bottom: 24px;
        }
        &-content{
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            background-color: #fff;
            box-sizing: border-box;
            margin-top: 12px;
            border-radius: 4px;
            padding: 0 16px;
            padding-bottom: 24px;
            .feedback-type {
                position: relative;
            }
            .form-title{
                font-weight: 600;
                display: flex;
                position: relative;
                flex: 1;
                flex-basis: 100%;
                font-size: 15px;
                color: #171A1D;
                margin-top: 40px;
                margin-bottom: 12px;
                &:nth-child(3){
                    margin-bottom: 2px;
                }
                &:nth-child(7){
                    margin-bottom: 2px;
                }
                &:nth-child(1){
                    margin-top: 20px;
                }
                span:nth-child(2){
                    font-size: 14px;
                    color: #F94F4E;
                    line-height: 15px;
                }
                
            }
            .selector-business{
                flex: 1;
                display: flex;
                justify-content: flex-end;
                .tip-text{
                    font-size: 14px;
                    color: #A2A3A4;         
                }
                .tip-text-active{
                    color: #171A1D;
                }
                .feedback-next{
                    width: 16px;
                    height: 16px;
                }    
            }
            .business-type{
                position: relative;
                display: flex;
                flex-wrap: wrap;
                margin-left: -8px;
                .business-type-item{
                    display: flex;
                    margin-top: 10px;
                    justify-content: space-between;
                    margin-left: 8px;
                    padding: 10px;
                    color: #36B374;
                    border: solid #36B374 0.5px;
                    background: rgba(54,179,116,0.05);
                    box-sizing: border-box;
                    .feedback-close{
                        width: 12px;
                        height: 12px;
                        margin-left: 6px;
                    }
                }
            }
            .feedback-upload{
                display: flex;
                flex-wrap: wrap;
                margin-left: -8px;
                .upload-camera,.upload-img{
                    width: 76px;
                    height: 76px;
                    border-radius: 4px;
                    margin-top: 10px;
                }
                .upload-camera{
                    margin-left: 12px;
                }
                .upload-camera-none{
                    margin-left: 0;
                }
                .upload-item{
                    display: flex;
                    flex-wrap: wrap;
                    position: relative;
                    margin-left: 12px;
                }
                /deep/ .van-uploader{
                    top: 0!important;
                }
                .upload-delete{
                    position: absolute;
                    top: 4px;
                    right: -6px;
                    width: 18px;
                    height: 18px;
                }
            }
            
        }

        &-type{
            display: flex;
            .type-item{
                span {
                    &:first-of-type {
                        font-weight: 600;
                    }
                }
                flex-grow: 1;
                display: flex;
                flex-wrap: wrap;
                margin-left: 8px;
                border-radius: 2px;
                border: solid #A2A3A4 0.5px;
                padding: 12px 0 14px 0;
                &:nth-child(1){
                    margin-left: 0;
                }
                span{
                    flex-basis: 100%;
                    text-align: center;
                    flex-grow: 1;
                    flex-shrink: 1;
                }
                span:nth-child(1){
                    font-size: 14px;
                    color: #171A1D;
                    font-family: PingFangSC-Medium;
                }
                span:nth-child(2){
                    margin-top: 8px;
                    font-size: 12px;
                    color: #71747A;
                }
            } 
            .type-item-active{
                color: #36B374;
                border: solid #36B374 0.5px;
                background: rgba(54,179,116,0.05);
                span:nth-child(1){
                    color: #36B374;
                    font-family: PingFangSC-Medium;
                }
                span:nth-child(2){
                    color: #36B374;
                }
            }
        }

        .description{
            width: 100%;
            position: relative;
            /deep/ .van-cell{
                // height: 160px;
                background: #F8F9FB;
                border-radius: 4px;
                padding-bottom: 28px;
                .van-field__control{
                    // height: 134px;
                }
            }
            .description-limit{
                font-size: 14px;
                color: #ccc;
                position: absolute;
                bottom: 12px;
                right: 12px;
            }
        }

        &-submit{
            width: 100%;
            height: 90px;
            background-color: #fff;
            position: fixed;
            bottom: 0;
            left: 0;
            padding: 0 16px;
            .feedback-button{
                width: 100%;
                margin-top: 8px;
                font-size: 16px;
                font-family: PingFangSC-Medium;
            }
            .feedback-button-disabled{
                opacity: 0.5;
            }
            /deep/ .van-button{
                border-radius: 4px;
            }
        }
    }
</style>